import React, { useState, useContext } from "react";
import axios from "axios";
import { AppContext } from "../../context/AppContext";
import "./Css/like.css";

const LikedGame = () => {
  const [likes, setLikes] = useState(0);
  const [dislikes, setDislikes] = useState(0);
  const [loading, setLoading] = useState(false);
  const { baseUrl, gameId } = useContext(AppContext);
  const [user, setUser] = useState(null);

  const handleLike = async () => {
    try {
      setLoading(true);
      const res = await axios.post(`${baseUrl}/like`, {
        gameId,
        user,
      });
      setLikes(res.data.likes);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDislike = async () => {
    try {
      setLoading(true);
      const res = await axios.post(`${baseUrl}/dislike`, { gameId, user });
      setDislikes(res.data.dislikes);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex gap-4 items-center">
      <button onClick={handleLike} disabled={loading} className="like_bt">
        👍
      </button>
      <button
        onClick={handleDislike}
        disabled={dislikes > 1}
        className="like_bt"
      >
        👎
      </button>
    </div>
  );
};

export default LikedGame;
